import apiClient, { extractData } from "./client";

export async function listTimesheets(params = {}) {
  const response = await apiClient.get("/timesheets", { params });
  return extractData(response);
}

export async function getTimesheet(id) {
  const response = await apiClient.get(`/timesheets/${id}`);
  return extractData(response);
}

export async function getBranchTimesheetEmployees(branchId) {
  const response = await apiClient.get("/timesheets/branch-employees", {
    params: branchId ? { branchId } : {},
  });
  return extractData(response);
}

export async function createTimesheet(data) {
  const response = await apiClient.post("/timesheets", data);
  return extractData(response);
}

/** IC: assign camera watches by employee + branch + day + hours. */
export async function assignInternalControlWatches(data) {
  const response = await apiClient.post(
    "/timesheets/internal-control/assignments",
    data,
  );
  return extractData(response);
}

export async function updateTimesheet(id, data) {
  const response = await apiClient.patch(`/timesheets/${id}`, data);
  return extractData(response);
}

export async function submitTimesheet(id) {
  const response = await apiClient.post(`/timesheets/${id}/submit`);
  return extractData(response);
}

export async function cancelTimesheet(id) {
  const response = await apiClient.post(`/timesheets/${id}/cancel`);
  return extractData(response);
}

export async function deleteTimesheet(id) {
  const response = await apiClient.delete(`/timesheets/${id}`);
  return extractData(response);
}

export async function approveTimesheet(id, data = {}) {
  const response = await apiClient.post(`/timesheets/${id}/approve`, data);
  return extractData(response);
}

export async function rejectTimesheet(id, data = {}) {
  const response = await apiClient.post(`/timesheets/${id}/reject`, data);
  return extractData(response);
}

/**
 * HR: set monthly timesheet REST day allotment.
 * @param {{ target: string, departmentId?: string, employeeIds?: string[], year: number, month: number, allottedDays: number, reason?: string }} data
 */
export async function grantMonthlyRestQuota(data) {
  const response = await apiClient.post("/timesheets/rest-quota/grant", data);
  return extractData(response);
}

/** HR: list monthly REST quotas */
export async function listMonthlyRestQuotas(params = {}) {
  const response = await apiClient.get("/timesheets/rest-quota", { params });
  return extractData(response);
}

/** HR: update a monthly REST quota */
export async function updateMonthlyRestQuota(id, data) {
  const response = await apiClient.patch(`/timesheets/rest-quota/${id}`, data);
  return extractData(response);
}

/** HR: delete a monthly REST quota (reverts to default 4) */
export async function deleteMonthlyRestQuota(id) {
  const response = await apiClient.delete(`/timesheets/rest-quota/${id}`);
  return extractData(response);
}
